<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Grid.scss";
</style>

<template>
    <div class="grid-container">
        <div class="item-grid-view vx-row match-height mt-4 cursor-pointer">
            <div :key="item.objectID" @click="goToDetail(item.id_label)" class="vx-col lg:w-1/4 sm:w-1/2 w-full" v-for="item in response">
                <vx-card class="grid-view-item mb-base overflow-hidden">
                    <gridPrincipalItem
                      :name="item.alias_label"
                      :description="$t('Labels.Alias')"
                      img="label"
                    ></gridPrincipalItem>
                    <vs-divider/>
                    <valueItem
                      v-if="item.alias_device"
                      :value="item.alias_device"
                      :description="$tc('Devices',1)"
                      img="cpu"
                    ></valueItem>
                    <div v-else class="text-center">{{$t('Labels.NotAssigned')}}</div>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>
import { request } from '@/request.js'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'

export default {
  components: {
    gridPrincipalItem,
    valueItem
  },
  data () {
    return {
      response: [],
      urlDownload: '',
      types: {
        F: 'Flujo de Aire',
        T: 'Temperatura y Humedad',
        E: 'Energía',
        P: 'Puertas',
        A: 'Agro'
      }
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()

      const params = {
        url: 'modelo/labels',
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.createCsv()
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    goToDetail (uuid) {
      window.location.href = `/labels/detail/${uuid}`
    },

    createCsv () {
      const csv = []
      const headers = []
      headers.push('Alias')
      headers.push('Dispositivo')
      headers.push('Tipo')
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.alias_label)
        row.push(item.alias_device)
        row.push(this.types[item.device_type])
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    }

  },

  created () {
    this.getResponse()
  }
}
</script>

<style scoped="">
    >>> .vs-sidebar {
  z-index: 999999;
}
</style>
